var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "absolute m-4 p-3",
      attrs: {
        src: "/ressources/public/img/IconSvgLogoSellsyText.svg",
        width: "154"
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-column hp-10 ai-center jc-center mt-4" },
      [
        _c("img", {
          staticClass: "wp-3 h-auto mb-4",
          attrs: { src: "/ressources/public/img/error/error404.svg" }
        }),
        _vm._v(" "),
        _c("h2", { staticClass: "gray-100" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _vm.message.length
          ? _c("p", { staticClass: "gray-60 mb-0" }, [
              _vm._v(_vm._s(_vm.message))
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("CompassButton", {
          staticClass: "mt-5",
          attrs: {
            label: _vm.buttonOptions.label,
            type: "primary",
            size: "large"
          },
          on: { click: _vm.goTo }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }